import EntityType from "@mapmycustomers/shared/enum/EntityType";
import IntegrationService from "@mapmycustomers/shared/enum/integrations/IntegrationService";
import { EntityTypesSupportedByIntegrations } from "@mapmycustomers/shared/types/entity";

import configService from "@app/config/ConfigService";
import {
  dynamicsLogo,
  hubspotLogo,
  netsuiteLogo,
  salesforceLogo,
  zohoLogo,
} from "@app/scene/settings/component/Integrations/logo";
import INTEGRATION_SERVICE_NAMES from "@app/util/integrations/integrationServiceNames";

import styles from "./services.module.scss";

export type ServiceDescription = {
  className?: string;
  enabled: boolean;
  logo: string;
  name: string;
  sandboxUrl?: string;
  shortName?: string;
  supportedEntityTypes: EntityTypesSupportedByIntegrations[];
  type: IntegrationService;
  url?: string;
};

const SUPPORTED_SERVICES: ServiceDescription[] = [
  {
    className: styles.hubspot,
    enabled: true,
    logo: hubspotLogo,
    name: INTEGRATION_SERVICE_NAMES[IntegrationService.HUBSPOT],
    supportedEntityTypes: [
      EntityType.COMPANY,
      EntityType.PERSON,
      EntityType.DEAL,
      EntityType.ACTIVITY,
    ],
    type: IntegrationService.HUBSPOT,
    url: configService.getHubspotAuthUrl(),
  },
  {
    className: styles.salesforce,
    enabled: true,
    logo: salesforceLogo,
    name: INTEGRATION_SERVICE_NAMES[IntegrationService.SALESFORCE],
    sandboxUrl: configService.getSalesforceSandBoxAuthUrl(),
    supportedEntityTypes: [
      EntityType.COMPANY,
      EntityType.PERSON,
      EntityType.DEAL,
      EntityType.ACTIVITY,
    ],
    type: IntegrationService.SALESFORCE,
    url: configService.getSalesforceAuthUrl(),
  },
  {
    className: styles.zoho,
    enabled: true,
    logo: zohoLogo,
    name: INTEGRATION_SERVICE_NAMES[IntegrationService.ZOHO],
    supportedEntityTypes: [
      EntityType.COMPANY,
      EntityType.PERSON,
      EntityType.ACTIVITY,
      EntityType.DEAL,
    ],
    type: IntegrationService.ZOHO,
    url: configService.getZohoAuthUrl(),
  },
  {
    className: styles.dynamics,
    enabled: true,
    logo: dynamicsLogo,
    name: INTEGRATION_SERVICE_NAMES[IntegrationService.DYNAMICS],
    shortName: "Dynamics",
    supportedEntityTypes: [
      EntityType.COMPANY,
      EntityType.PERSON,
      EntityType.ACTIVITY,
      EntityType.DEAL,
    ],
    type: IntegrationService.DYNAMICS,
    url: configService.getDynamicsAuthUrl(),
  },
  {
    className: styles.netsuite,
    enabled: true,
    logo: netsuiteLogo,
    name: INTEGRATION_SERVICE_NAMES[IntegrationService.NETSUITE],
    supportedEntityTypes: [
      EntityType.COMPANY,
      EntityType.PERSON,
      EntityType.ACTIVITY,
      EntityType.DEAL,
    ],
    type: IntegrationService.NETSUITE,
  },
];

export default SUPPORTED_SERVICES;
